export type AdminTab = {
  path: string;
  name: string;
};

export enum AddUserVariants {
  INVITE = 'invite',
  PERMISSIONS = 'permissions',
}

export type AddUserVariant = AddUserVariants.INVITE | AddUserVariants.PERMISSIONS;

export enum UserStatuses {
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DISABLED = 'DISABLED',
  BLOCKED = 'BLOCKED',
  CONFIRMED = 'CONFIRMED',
  UNCONFIRMED = 'UNCONFIRMED',
}

export type UserStatus =
  | UserStatuses.INVITED
  | UserStatuses.ACTIVE
  | UserStatuses.DISABLED
  | UserStatuses.PENDING
  | UserStatuses.BLOCKED
  | UserStatuses.CONFIRMED
  | UserStatuses.UNCONFIRMED;

export enum RatingStatuses {
  APPROVED = 'APPROVED',
  REVOKED = 'REVOKED',
  INVITED = 'INVITED',
}

export type RatingStatus =
  | RatingStatuses.APPROVED
  | RatingStatuses.REVOKED
  | RatingStatuses.INVITED;
export enum SubscriberConfirmations {
  BLANK = '',
  SIGNED = 'SIGNED',
  SENT = 'SENT',
}

export type SubscriberConfirmation =
  | SubscriberConfirmations.BLANK
  | SubscriberConfirmations.SIGNED
  | SubscriberConfirmations.SENT;

export enum RatingTypes {
  ISSUE = 'ISSUE',
  ISSUER = 'ISSUER',
}

export type RatingType = RatingTypes.ISSUE | RatingTypes.ISSUER;

export enum ContractTypes {
  SOLICITED = 'ISSUER_SOLICITED',
  REQUESTED = 'INVESTOR_REQUESTED',
}

export type ContractType = ContractTypes.SOLICITED | ContractTypes.REQUESTED;

export type UserRating = {
  entityId: string;
  entityName: string;
  entityType: string;
};

export type User = {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  userStatus: UserStatus;
  newRsrUser?: boolean;
  organisationId?: string;
  organisationName?: string;
  confirmation: SubscriberConfirmation;
  accessibleRatings?: Array<UserRating>;
  approvedRatings?: Array<UserRating>;
};

export type Rating = {
  entityId: string;
  ratingId: string;
  entityName: string;
  contractType: ContractType;
  entityType: RatingType;
  ratingType: string;
  numberOfUsers?: number;
};

export type RatingUser = {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  newRsrUser: boolean;
  organisationId: string;
  organisationName: string;
  userStatus: UserStatus;
  confirmation: SubscriberConfirmation;
  ratingStatus: RatingStatus;
  ratingStatusDate: Date;
};

export type UserRatingStatus = {
  userId: string;
  ratingEntityId: string;
  ratingEntityType: string;
  status: RatingStatus;
  statusDate: Date;
  modifiedBy: string;
  modifiedByName?: string;
  modifiedByEmail?: string;
};

export type SubscriptionRatingType = 'rsr' | 'psr';
